/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_Compare_TitleInputs */

const cs_portals_sync_compare_title = /** @type {(inputs: Portals_Sync_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM vs portál`)
};

const en_portals_sync_compare_title = /** @type {(inputs: Portals_Sync_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM vs portal`)
};

/**
* | output |
* | --- |
* | "CRM vs portal" |
*
* @param {Portals_Sync_Compare_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_compare_title = /** @type {((inputs?: Portals_Sync_Compare_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Compare_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_compare_title(inputs)
	return cs_portals_sync_compare_title(inputs)
});